import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import {IPickerColorProperties, IElement, ITextAttributes} from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById, findDifferentAttributeValues } from "@utils/editor";
import arrowdown from "assets/svgs/arrowdown.svg";
import arrowup from "assets/svgs/arrowup.png";
import A from "assets/svgs/A.svg";
import Tooltip from '@components/Tooltip';

const FontColorComandOption:React.FC<IProps> = (props) => {
  let context = useContext(Context);
  const [fontColors, setFontColors]= useState<string[]>([]);
  const [isSelected, setIsSelected]= useState(false);

  useEffect(() => {
    const colors = findDifferentAttributeValues(context.editorStatus.selectedElementsId, context.data, "color", "Text", context.editorStatus.textSelectionInformation);
    setFontColors(colors);
  }, [context.editorStatus.selectedElementsId.length, context.editorStatus.selectedElementsId[0], context.data, context.editorStatus.textSelectionInformation]);

  useEffect(() => {
    if (context.editorStatus && context.editorStatus.currentPicker === "Color" && (context.editorStatus.pickerProperties as IPickerColorProperties)?.colorAttribute==="color") setIsSelected(true);
    else setIsSelected(false);
  }, [context.editorStatus.currentPicker,context.editorStatus.pickerProperties]);

  const SetColorSelecting = () => {  
    const picker = (context.editorStatus.currentPicker==="Color")?undefined:"Color";
    context.onShowPicker(picker,{elementType: "Text", colorAttribute: "color"});
  }

  return (
    <S.Root>
      <Tooltip tip={"Text Color"}>
        <S.ButtonContainer onClick={SetColorSelecting} isSelected={isSelected}>
          <img src={A}></img>
          <S.ColorRect>
           {
              fontColors.length===0 &&
              <>
                <S.ColorSection bgcolor={"#000000"} first={true} last={true}/>
              </>
            }
            {
              fontColors.length>0 &&
              <>
              {
                fontColors.map((fontColor, index) => {
                  return (
                    <S.ColorSection key={`color${index}`} bgcolor={fontColor} first={index===0} last={index===fontColors.length-1}/>
                  )
                })
              }
              </>
            }
          </S.ColorRect>
        </S.ButtonContainer>
      </Tooltip>
    </S.Root>
  );
}

export default FontColorComandOption;